import { useRootStore } from 'stores/RootStore'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { RatingsExtraFeedbackProps } from 'components/RatingsExtraFeedbackDrawer/Types'
import { RatingsExtraFeedbackDrawer } from 'components/RatingsExtraFeedbackDrawer/RatingsExtraFeedbackDrawer'
import { useCallback, useMemo } from 'react'
import { useModals } from 'almanac-ui/Modal'
import { RatingsExtraFeedbackModal } from 'components/RatingsExtraFeedbackModal/RatingsExtraFeedbackModal'

export const useOpenRatingsExtraFeedback = () => {
  const { drawersStore } = useRootStore()
  const { openDrawer, closeDrawer } = drawersStore
  const { openModal, closeModal } = useModals()
  const { isMobile } = useResponsiveDesign()

  const open = useCallback(
    (props: RatingsExtraFeedbackProps) => {
      if (isMobile) {
        return openDrawer(RatingsExtraFeedbackDrawer, props)
      }

      return openModal(RatingsExtraFeedbackModal, props, { newStack: true })
    },
    [isMobile, openDrawer, openModal],
  )

  const close = useMemo(() => {
    if (isMobile) {
      return closeDrawer
    }
    return closeModal
  }, [isMobile, closeDrawer, closeModal])

  return {
    open,
    close,
  }
}
